/* eslint-disable @typescript-eslint/restrict-plus-operands */
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';
import { useTranslation } from 'react-i18next';

export const AnalysisChart = () => {
  const { t } = useTranslation();
  const data = [
    { days: 0, hours: 1.3 },
    { days: 0.5, hours: 1.6 },
    { days: 1, hours: 1.9 },
    { days: 1.5, hours: 2.3 },
    { days: 2, hours: 2.7 },
    { days: 2.5, hours: 3.0 },
    { days: 3, hours: 3.2 },
    { days: 3.5, hours: 3.3 },
    { days: 4, hours: 3.2 },
    { days: 4.5, hours: 3.0 },
    { days: 5, hours: 2.8 },
  ];
  const baselineValue = 3;

  return (
    <div
      style={{
        width: '100%',
        height: '400px',
      }}
    >
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 70, left: 0, bottom: 20 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#1e3a5f"
            vertical={false}
          />
          <XAxis
            dataKey="days"
            stroke="#64748b"
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            axisLine={{ stroke: '#1e3a5f' }}
            domain={[0, 5]}
            ticks={[0, 1, 2, 3, 4, 5]}
          />
          <YAxis
            stroke="#64748b"
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            axisLine={{ stroke: '#1e3a5f' }}
            label={{
              value: 'Engine Hours',
              angle: -90,
              position: 'insideLeft',
              fill: '#94a3b8',
              fontSize: 12,
              dy: 40,
              dx: 15,
            }}
            domain={[0, 4]}
            ticks={[0, 1, 2, 3, 4]}
          />
          <ReferenceLine
            y={baselineValue}
            stroke="#60a5fa"
            strokeDasharray="3 3"
            strokeWidth={1.5}
            label={(props: any) => {
              const { viewBox } = props;
              const { x, width, y } = viewBox;

              return (
                <text x={x + width + 8} y={y - 8} fill="#e5e7eb" fontSize={12}>
                  {t('baseline_3')}
                </text>
              );
            }}
          />
          <Line
            type="monotone"
            dataKey="hours"
            stroke="#f59e42"
            strokeWidth={2.5}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
